import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/** Raised card section for merchant detail / form inner pages. */
export function DetailSection({
  title,
  description,
  action,
  children,
  testId,
}: {
  title?: string;
  /** Short explanatory line rendered under the title. */
  description?: ReactNode;
  /** Right-aligned control rendered on the title row (e.g. a section-scoped save). */
  action?: ReactNode;
  children: ReactNode;
  testId?: string;
}) {
  return (
    <section className="mer-detail-section" data-testid={testId}>
      {title || action ? (
        <header className="mer-detail-section-head">
          <div className="mer-detail-section-heading">
            {title ? <h2 className="mer-detail-section-title">{title}</h2> : null}
            {description ? <p className="mer-detail-section-desc">{description}</p> : null}
          </div>
          {action ? <div className="mer-detail-section-action">{action}</div> : null}
        </header>
      ) : null}
      {children}
    </section>
  );
}

export function DetailPageShell({ children }: { children: ReactNode }) {
  return <div className="mer-detail-page">{children}</div>;
}

export function DetailBackLink({ to, children }: { to: string; children: ReactNode }) {
  return (
    <Link to={to} className="mer-detail-back">
      {children}
    </Link>
  );
}
